import { useState } from 'react'
import { Tabs, type TabItem } from '../../components/ui/index.js'
import { AdminAIGenerations } from './AdminAIGenerations.js'
import { AdminAIThemes } from './AdminAIThemes.js'
import styles from './AdminHistory.module.css'

const TABS: TabItem[] = [
  { key: 'generations', label: 'AI 생성' },
  { key: 'themes', label: 'AI 테마' },
]

export function AdminHistory() {
  const [activeTab, setActiveTab] = useState('generations')

  return (
    <div className={styles.root}>
      <Tabs items={TABS} value={activeTab} onChange={setActiveTab} variant="card" size="sm" />
      <div className={styles.tabContent}>
        {activeTab === 'generations' ? <AdminAIGenerations /> : <AdminAIThemes />}
      </div>
    </div>
  )
}
